export enum Model {
	BookingInfo = 'booking-info',
	Bookings = 'bookings',
	Clients = 'clients',
	Counters = 'counters',
	Dictionary = 'dictionary',
	Favorites = 'favorites',
	Interface = 'interface',
	MainResources = 'main-resources',
	MessageStatus = 'message-status',
	Notifications = 'notifications',
	ResourceCreationWizard = 'resource-creation-wizard',
	YandexIntegrationWizard = 'yandex-integration-wizard',
	ResourceTypes = 'resourceTypes',
	Resources = 'resources',
	WaitList = 'wait-list',
	Filter = 'filter',
	SaleChannels = 'sale-channels',
	SkuResourcesEditor = 'sku-resources-editor',
	ResourceSkuRelations = 'resource-sku-relations',
	Sku = 'sku',
}
